import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
export { Application } from './components/Application/Application';
export { default as SalePage } from './components/SalePage/SalePage';
export { default as ExpiredSalePage } from './components/ExpiredSalePage/ExpiredSalePage';
export { default as BookingOfferDetailsPage } from './components/BookingOfferDetails/BookingOfferDetailsPage';
export { default as CancellationPage } from './components/CancellationPage/CancellationPage';
export { default as BookingDetailsPage } from './components/BookingDetailsPage/BookingDetailsPage';
export { default as BookingsPage } from './components/BookingsPage/BookingsPage';
export { createBrowserHistory } from 'history';

const script: HTMLScriptElement = document.currentScript as HTMLScriptElement;
const path: string = script.src.replace('cauldron.min.js', '');

__webpack_public_path__ = path;
